import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../../services/api';

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password.length < 6) return setMsg({ type: 'error', text: 'Le mot de passe doit faire au moins 6 caractères.' });
        if (password !== confirm) return setMsg({ type: 'error', text: 'Les mots de passe ne correspondent pas.' });

        setLoading(true);
        setMsg(null);
        try {
            const { data } = await api.post('/auth/reset-password.php', { token, password });
            setMsg({ type: 'success', text: data.message });
        } catch (err) {
            setMsg({ type: 'error', text: err.response?.data?.message || 'Erreur' });
        }
        setLoading(false);
    };

    if (!token) {
        return (
            <div className="auth-page">
                <div className="auth-card">
                    <h2>Lien invalide</h2>
                    <p>Ce lien de r&eacute;initialisation est invalide ou a expir&eacute;.</p>
                    <Link to="/connexion" className="btn btn-primary" style={{ marginTop: '16px' }}>Retour &agrave; la connexion</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="auth-card">
                <h2>Nouveau mot de passe</h2>

                {msg?.type === 'success' ? (
                    <div>
                        <div className="alert alert-success">{msg.text}</div>
                        <Link to="/connexion" className="btn btn-primary" style={{ marginTop: '16px', width: '100%', textAlign: 'center' }}>Se connecter</Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {msg?.type === 'error' && <div className="alert alert-error">{msg.text}</div>}
                        <div className="auth-field">
                            <label>Nouveau mot de passe</label>
                            <input type="password" value={password} onChange={e => setPassword(e.target.value)} minLength={6} required autoFocus />
                        </div>
                        <div className="auth-field">
                            <label>Confirmer le mot de passe</label>
                            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} minLength={6} required />
                        </div>
                        <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                            {loading ? 'Modification...' : 'Modifier mon mot de passe'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
